/**
 * Fax Tour Configuration
 * Introduces users to the fax features
 */

import { TourDefinition } from './tour.types';

export const faxTour: TourDefinition = {
  id: 'fax-tour',
  name: 'Fax Center',
  page: '/fax',
  version: 4, // Added received fax tab
  nextTourId: 'resources-tour', // Chain to resources tour
  // Skip for trial users (they don't have fax access)
  allowedAccountTypes: ['basic', 'full_fledged'],
  steps: [
    {
      id: 'fax-intro',
      targetSelector: '[data-tour="fax-header"]',
      title: 'Fax Center',
      description:
        'Send and receive faxes digitally! No fax machine needed - manage all your fax communications right from the app.',
      placement: 'bottom',
    },
    {
      id: 'fax-tabs',
      targetSelector: '[data-tour="fax-tabs"]',
      title: 'Fax Options',
      description:
        'Switch between sending a new fax, viewing received faxes, or checking your fax history using these tabs.',
      placement: 'bottom',
    },
    {
      id: 'send-fax-tab',
      targetSelector: '[data-tour="fax-tab-send"]',
      title: 'Send a Fax',
      description:
        'Upload a document, enter the recipient fax number, and send it instantly. Your faxes are sent digitally through your dedicated fax number.',
      placement: 'bottom',
      onShow: () => {
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="fax-tab-send"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
    {
      id: 'received-fax-tab',
      targetSelector: '[data-tour="fax-tab-received"]',
      title: 'Received Faxes',
      description:
        'View all faxes that have been sent to your dedicated fax number. Download, print, or forward received documents to your leads.',
      placement: 'bottom',
      onShow: () => {
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="fax-tab-received"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
    {
      id: 'fax-history-tab',
      targetSelector: '[data-tour="fax-tab-history"]',
      title: 'Fax History',
      description:
        'View your complete fax history including all sent faxes. Check delivery status, resend failed faxes, and download documents.',
      placement: 'bottom',
      onShow: () => {
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="fax-tab-history"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
  ],
};
